module.exports = __webpack_public_path__ + "static/img/00054B_9_10_11_12_R_20200611_LC.acce4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00054B_9_10_11_12_R_20200611_LC.png
// module id = Z5G1
// module chunks = 0